/* eslint-disable max-classes-per-file */
/* eslint-disable class-methods-use-this */

/* eslint-disable no-underscore-dangle */
class StoreCheckoutBackend {
  constructor(jsonApi, storeId, parentPage, locale) {
    this.api = jsonApi;
    this.storeId = storeId;
    this.parentPage = parentPage;
    this.locale = locale;
    if (!this.api) {
      throw new Error('No jsonApi passed to StoreCheckoutBackend');
    }
    if (!this.storeId) {
      throw new Error('No storeId passed to StoreCheckoutBackend');
    }
  }

  async fetch(checkoutId) {
    const response = await this.api.get(
      `/embedded-checkout/pre-order-checkouts/${checkoutId}`
    );
    this._throwOnError(response);
    return response.data;
  }

  async create({ userSession, lineItemRequest, discountCode }) {
    const parentPageSessionToken =
      this.parentPage && (await this.parentPage.getParentPageSessionToken());

    const { userSessionId, ...res } = await this._callPostEndpoint(
      '/embedded-checkout/pre-order-checkouts/create',
      {
        storeId: this.storeId,
        parentPageSessionToken,
        userSessionId: userSession.id(),
        ...lineItemRequest.toObj(),
        salesChannel: getCheckoutSalesChannel(),
        locale: this.locale,
      }
    );

    userSession.set(userSessionId);

    if (discountCode) {
      const discountRes = await this._callPostEndpoint(
        '/embedded-checkout/pre-order-checkouts/add-discount-code',
        { checkoutId: res.checkoutId, code: discountCode, autoApplied: true }
      );

      return discountRes;
    }

    return res;
  }

  async addLineItem(checkoutId, lineItemRequest) {
    return await this._callPostEndpoint(
      '/embedded-checkout/pre-order-checkouts/add',
      {
        checkoutId,
        ...lineItemRequest.toObj(),
      }
    );
  }

  async replace(checkoutId, lineItemRequest) {
    return await this._callPostEndpoint(
      '/embedded-checkout/pre-order-checkouts/replace',
      {
        checkoutId,
        ...lineItemRequest.toObj(),
      }
    );
  }

  async _callPostEndpoint(url, body) {
    const response = await this.api.post(url, body);

    this._throwOnError(response);
    return response.data;
  }

  _throwOnError(response) {
    const { meta, error: resError } = response;

    // Stripe error is making it down to the frontend
    if (resError) {
      const error = new Error(resError.message);
      error.data = resError;
      error.serverSide = true;
      throw error;
    }

    if (meta.error) {
      const error = new Error(meta.error);
      error.data = meta.errorData;
      error.serverSide = true;
      throw error;
    }
  }
}

function getCheckoutSalesChannel() {
  const searchParams = new URLSearchParams(window.location.search);

  return searchParams.get('salesChannel') || undefined;
}

export default StoreCheckoutBackend;
